import React, { useState, useEffect } from 'react'
import { graphql } from "gatsby"
import { GatsbyImage, IGatsbyImageData, getImage } from "gatsby-plugin-image"
import * as styles from "./ImageGallery.css"
import { Text } from "../ui"
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import PhotoAlbum from "react-photo-album";
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import {
  breakpoints
} from "../../components/ui.css"

interface image {
  title: string
  gatsbyImageData: any
}

export type ImageGalleryProps = {
  title: string
  desktopRight: boolean
  galleryDescription: string
  positionDescAboveGallery: boolean
  displayFullWidth: boolean
  layout: any
  images: [image]
}

interface Slide {
  src: string;
  width: number;
  height: number;
  alt: string;
  title: string;
}

const getWindowWidth = () => window.innerWidth 
  || document.documentElement.clientWidth 
  || document.body.clientWidth

const desktopBool = () => {
  if (typeof window !== "undefined") {
    return getWindowWidth() > breakpoints[2] ? true : false
  }
}

export default function ImageGallery(props: ImageGalleryProps) {

  const { images, title, layout, desktopRight, galleryDescription, positionDescAboveGallery, displayFullWidth } = props;

  const [index, setIndex] = React.useState(-1);
  const [isDesktop, setIsDesktop] = useState(desktopBool())
  const [hasWindow, setHasWindow] = useState(false)

  const slides: Slide[] = images.map((image:image ) => ({
    src: image.gatsbyImageData.images?.fallback?.src,
    width: image.gatsbyImageData.width,
    height: image.gatsbyImageData.height,
    alt: image?.title,
    title: image?.title,
  }));
 
  const defaultMaxImagesPerRow = 5;
  const maxImagesPerRowCount = (slides.length < defaultMaxImagesPerRow) ? slides.length : defaultMaxImagesPerRow;

    
  useEffect(() => {
    const handleIsDesktop = () => {
      setIsDesktop(desktopBool())
    }
    if (typeof window !== "undefined") {
      setHasWindow(true)
      window.addEventListener('resize', handleIsDesktop);
      return () => {
        window.removeEventListener('resize', handleIsDesktop);
      }
    }
  }, [])

  return (
    <div style={{width: "100%", marginBottom: "40px"}}>
      {(title) ? <Text as="h2" center className={styles.headerH2} variant="superHeading">{title}</Text> : null }
      
      {(positionDescAboveGallery) ?
        <div style={{clear: "both", fontSize: "14px", textAlign: "center"}}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{galleryDescription}</ReactMarkdown>
        </div> 
      : null}

      <div>
        <PhotoAlbum
          layout={layout}
          photos={slides}
          columns={(containerWidth) => {
            if (containerWidth < 640) return 1; //was 350
            if (containerWidth < 700) return (maxImagesPerRowCount > 2 ? 2 : maxImagesPerRowCount);
            if (containerWidth < 800) return (maxImagesPerRowCount > 3 ? 3 : maxImagesPerRowCount); 
            if (containerWidth < 1200) return maxImagesPerRowCount;
            
            return maxImagesPerRowCount;
          }}
          //this onclick function is for the lightbox
          //onClick={({ index: current }) => setIndex(current)}
          onClick={({ index: current }) => {
            if(isDesktop) {
              setIndex(current);
            } else {
              const selectedImage = slides[current];
              if (selectedImage?.src) {
                window.open(selectedImage.src, '_blank');
              }
            }
          }
        }
        />
      </div>
      <Lightbox
        index={index}
        slides={slides}
        open={index >= 0}
        close={() => setIndex(-1)}
      />

      {(!positionDescAboveGallery) ? 
        <div style={{clear: "both", fontSize: "14px", textAlign: "center"}}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{galleryDescription}</ReactMarkdown>
        </div> 
      : null}      

    </div>
  );
}

export const query = graphql`
  fragment ImageGalleryContent on ImageGallery {
    id
    ... on DatoCmsImageGallery {
      id
      title
      desktopRight
      galleryDescription
      positionDescAboveGallery
      layout
      displayFullWidth
      images {
        id
        ... on DatoCmsAsset {
          title
          gatsbyImageData(
            imgixParams: {fit: "max", w: "1200"}
          )
        }
      }
    }
  }
`